import React, { useContext } from 'react';
import { context } from '@catalogo/ui-americanas-desktop-product-review/src/context';
import { useHandlePaginate } from '@catalogo/ui-americanas-desktop-product-review/src/hooks';
import { Button } from '@catalogo/ui-americanas-desktop-product-review/src/components/atoms';
import { Wrapper } from './Styled';

const ButtonMoreView = () => {
  const { handlePaginate } = useHandlePaginate();
  const { data } = useContext(context);
  const { fetchMoreLoading, comments, reviews } = data;
  const hasMoreReview = reviews?.length < comments;

  if (hasMoreReview && !fetchMoreLoading) {
    return (
      <Wrapper className="product-review-reviews-button-more-view">
        <Button loading={fetchMoreLoading} onClick={handlePaginate}>
          ver mais comentários
        </Button>
      </Wrapper>
    );
  }

  return null;
};

export default ButtonMoreView;
export { ButtonMoreView };
